import { connect } from 'react-redux';
import DuplicateModal from './DuplicateModal';
import { duplicateFloor } from '../../redux/floor/floor_actions';

const mapStateToProps = state => ({
  isDuplicating: state.floor.isDuplicating,
  errorMessage: state.floor.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  duplicate: (id, name) => dispatch(duplicateFloor(id, name)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DuplicateModal);



// WEBPACK FOOTER //
// ./src/modal/duplicate/FloorDuplicateModal.js